import Vue from 'vue'
import VueRouter from 'vue-router'
import path from 'path'
import store from '@/store'

Vue.use(VueRouter)

export const routesObj = {}

const modules = require.context('./modules', true, /\.js/)
modules.keys().forEach(item => {
	const modulesName = path.basename(item, '.js')
	routesObj[modulesName] = modules(item).default || modules(item)
})

const router = new VueRouter({
	routes: [
		{
			path: '/',
			redirect: '/personal/personal'
		},
		...Object.values(routesObj).flat()
	]
})

router.beforeEach((to, from, next) => {
	if (to.query.openid) {
		store.commit('account/SET_OPENID', to.query.openid)
	}
	if (to.query.unionid) {
		store.commit('account/SET_UNIONID', to.query.unionid)
	}
	store.dispatch("account/getDetectTypeList");
	next()
})

router.afterEach(to => {
	// 设置 title
	document.title = to.meta.title || '加载中...'
})
export default router
